import './CodeExchangeCard.scss';
import React from "react";
import colors from "./resource/colors"

export default class CodeExchangeCard extends React.Component {
    static defaultProps = {
        data: {}
    };
    state={
        logoLoaded:false,
        logoError:false 
     }
 
     handleLoad=()=>{
         this.setState({logoLoaded:true})
     }
 
     handleError=()=>{
         this.setState({logoError:true})
     }
 
    constructor(props) {
        super(props);
        if (props.data.textContent) {
            this.state = { ...this.state,entry: JSON.parse(props.data.textContent) };
        } else {
            this.state = { ...this.state,entry: props.data };
        }
    }

    render() {
        const {entry}=this.state;
        if (!entry) {
            return null;
        }
        const language = entry['programmingLanguages'] && entry['programmingLanguages'][0];
        const owner = this.parseOwner(entry);
        const title = this.parseTitle(entry)
        const description = entry.description;
        const tags = this.renderTags(entry);
        const repoURL = this.buildRepoUrl(entry);
        return (
            <div className='pubhub-code-exchange-card pubhub-widget' id={this.props.id} style={this.props.style}>
                {/* <a href={repoURL} target={this.props.target}> */}
                    <div className="entry">
                        <div className="entry-head">
                            <div className="entry-language">
                                <div className="entry-language-color" style={{ "background": colors[language] ? colors[language].color : "gold" }}></div>
                                <div className="entry-language-name">{language}</div>
                            </div>
                            <div className="intent-icon intent-fork"><i className="fas fa-code-branch"></i>
                                <div className="entry-number">{entry.meta.forksCounts}</div>
                            </div>
                            <div className="intent-icon intent-star"><i className="fas fa-star"></i>
                                <div className="entry-number">{entry.meta.stargazersCount}</div>
                            </div>
                        </div>
                        <div className="entry-content">
                            <div className="entry-owner">{owner}</div>
                            <a className="entry-title-url" href={repoURL} target={this.props.target} rel={this.props.target === '_blank' ? 'noopener noreferrer' : undefined}><div className="entry-title">{title}</div></a>
                            <div className="entry-description">{description}</div>
                        </div>
                        <div className="entry-tags">
                            {tags}
                        </div>
                    </div>
                {/* </a> */}
            </div>
        );
    }

    renderTags(entry) {
        return (entry.categories || []).map(tag =>
            <a href={this.getRepoHost() + "/codeexchange#tech=" + tag} key={tag}>
                <div className="entry-tag">{tag}</div>
            </a>);
    }

    parseOwner(entry) {
        const tileNameParts = entry.name ? entry.name.split('/') : [];

        let owner = tileNameParts.length > 0 ? tileNameParts[0] : 'CISCO';
        if (!entry.additionalTags) {
            return owner;
        }
        entry.additionalTags.map(tag => {
            let params = tag.split(':');
            if (params[0] === 'owner')
                owner = params[1];
        });

        return owner;
    }

    parseTitle(entry) {
        let params = entry.name && entry.name.split('/');
        if (!params) return '';

        if (params.length === 1) return params[0];

        if (params.length === 2) return params[1];

        params.shift();
        return params.join('/');
    }

    getRepoHost() {
      return this.props.repohost || '';
    }

    buildRepoUrl(entry) {
        return (
            this.getRepoHost()
            + '/codeexchange/github/repo/'
            + entry.name
            + (this.props.repourlquerystring ? ("?" + this.props.repourlquerystring) : ""));
    }
}
